








































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import IconButton from '@c/controls/IconButton.vue';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {
  SelectionListFilterModel,
  SelectionListGroupingModel,
} from '@/components/controls/selectionList/interfaces';
import draggable from 'vuedraggable';
import SimpleDialog from '@c/SimpleDialog.vue';
import {PModule, PModuleWithCoords} from '@/views/system/modules/interfaces';
import {NodeData} from '@/system/nodes/interfaces';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import nodeModule from '@/store/modules/entities/nodeModule';
import {pmoduleTypeFilter} from '@/components/nodeComponent/filters';
import {pmoduleGroupings} from '@/components/nodeComponent/groupings';
import {PModuleType} from '@/enums/configs';

@Component({components: {IconButton, SelectionList, draggable, SimpleDialog}})
export default class NodeMenu extends Vue {
  // Фильтр программных модулей по типу
  pmoduleTypeFilter: SelectionListFilterModel = pmoduleTypeFilter;

  // Список группировок программных модулей
  pmoduleGroupings: SelectionListGroupingModel[] = pmoduleGroupings;

  file = null;
  dialogSvgModel = false;
  dialogPModulesModel = false;
  commonPModules: PModule[] = [];

  @Prop({required: true, type: Boolean})
  editFlag!: boolean;

  @Prop()
  nodeId!: number;

  @Prop({required: true})
  selectedPModule!: PModuleWithCoords;

  @Prop({required: true})
  selectedLink!: NodeData;

  @Prop({required: true, type: Array})
  availablePModules!: PModuleWithCoords[];

  @Prop({required: true, type: Array})
  placedPModules!: PModuleWithCoords[];

  @Prop({required: true, type: Array})
  availableLinks!: NodeData[];

  @Prop({required: true, type: Array})
  fullNodePModulesIds!: string[];

  commonPModulesModel = [...this.fullNodePModulesIds];

  showMenuPModule = false;
  showMenuLink = false;

  enableToEdit = false;

  showAllPM = false;

  availableModules = null;

  @Watch('availablePModules')
  changeAvaliablePModules(newVal: any) {
    this.availableModules = newVal.filter((x: any) => x.type != PModuleType.HeaterMonitorModule);
  }

  @Watch('showAllPM')
  async changePMList(newVal: any) {
    if (newVal) this.commonPModules = [...pmoduleModule.all];
    else
      this.commonPModules = this.commonPModules.filter(
        x => !x.nodes || x.nodes?.filter(pos => pos.node_id == this.nodeId).length > 0,
      );
    this.commonPModulesModel = [...this.fullNodePModulesIds];
  }

  async created() {
    await pmoduleModule.fetchAll();
    this.commonPModules = [
      ...pmoduleModule.all.filter(
        x => !x.nodes || x.nodes?.filter(pos => pos.node_id == this.nodeId).length > 0,
      ),
    ];
    this.checkPermiss();
  }

  // метод проверки полномочий для изменения узла
  checkPermiss() {
    const permisString = localStorage.getItem('permissions');
    let permissions = [];
    if (permisString) permissions = JSON.parse(permisString);

    const bool = permissions.some(
      (permis: any) => permis.action == 'edit' && permis.obj == 'nodes_journal',
    );
    this.enableToEdit = bool;
  }

  // Обработчик перемещения узла
  onMovePModule(evt: any) {
    this.$emit('itemMove', evt);
    this.showMenuPModule = false;
    return false;
  }

  // Обработчик перемещения ссылки
  onMoveLink(evt: any) {
    this.$emit('itemMove', evt);
    this.showMenuLink = false;
    return false;
  }

  // Обработчик окончания перемещения узла
  dragEndPModule(item: PModuleWithCoords) {
    this.showMenuPModule = true;
    this.$emit('dragEndPModule', item);
  }

  // Обработчик окончания перемещения ссылки
  dragEndLink(item: NodeData) {
    this.showMenuLink = true;
    this.$emit('dragEndLink', item);
  }

  @Watch('fullNodePModulesIds', {immediate: true})
  watchFullNodePModulesIds(items: string[]) {
    this.commonPModulesModel = [...items];
  }

  get computedEditFlag() {
    return this.editFlag ? 'content-save' : 'pencil';
  }

  onClickEdit() {
    if (!this.enableToEdit) return;
    if (this.editFlag) {
      this.$emit('updatePModules');
      this.$emit('updateLinks');
    } else this.$emit('changeEditFlag', !this.editFlag);
  }

  onClickCancel() {
    if (!this.enableToEdit) return;
    this.$emit('clickCancel', !this.editFlag);
  }

  onSelectPModule(item: any) {
    this.$emit('selectPModule', item);
  }

  onSelectLink(item: any) {
    this.$emit('selectLink', item);
  }

  onSubmitSvgForm() {
    if (!this.enableToEdit) return;
    this.dialogSvgModel = false;
    this.$emit('updateScheme', this.file);
  }

  onClickCancelSelect() {
    if (!this.enableToEdit) return;
    this.dialogPModulesModel = false;
    this.commonPModulesModel = [...this.fullNodePModulesIds];
  }

  async onSubmitPModulesForm() {
    if (!this.enableToEdit) return;
    this.dialogPModulesModel = false;
    const selectedCommonPModules = this.commonPModules
      .filter(
        x =>
          this.commonPModulesModel.some(z => z == x.guid) &&
          !this.placedPModules.some(z => z.guid == x.guid),
      )
      .map(x => x as PModuleWithCoords);
    const selectedPlacedPModules = this.placedPModules.filter(
      x =>
        this.commonPModulesModel.some(z => z == x.guid) &&
        x.nodes &&
        x.nodes.filter(pos => pos.node_id == this.nodeId).length > 0,
    );
    const selectedPModules = selectedCommonPModules.concat(selectedPlacedPModules);
    await nodeModule.batchSetModules({
      id: this.nodeId,
      modules: selectedPModules.map(e => ({
        guid: e.guid as string,
        x: e.coords?.x,
        y: e.coords?.y,
      })),
    });
    this.$emit('updateNodePModules');
  }
}
